
console.log("scripts/index.js says hello");



